import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const assetUrl = (id) => (id ? `${API}/assets/${id}` : null);
export const downloadUrl = (id, name) => (id ? `${API}/assets/${id}?download=${encodeURIComponent(name)}` : null);
export const exportUrl = (projectId, kind) => `${API}/projects/${projectId}/${kind}`;

export const downloadBlob = async (url, filename) => {
  const r = await axios.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
};

export const api = {
  listProjects: () => axios.get(`${API}/projects`).then((r) => r.data),
  getProject: (id) => axios.get(`${API}/projects/${id}`).then((r) => r.data),
  createProject: (payload) => axios.post(`${API}/projects`, payload).then((r) => r.data),
  deleteProject: (id) => axios.delete(`${API}/projects/${id}`).then((r) => r.data),
  detectLanguage: (text) => axios.post(`${API}/detect-language`, { text }).then((r) => r.data),
  pageNarration: (id, idx) => axios.post(`${API}/projects/${id}/pages/${idx}/narration`).then((r) => r.data),
  listVoices: () => axios.get(`${API}/voices`).then((r) => r.data),
  transcribe: (blob, ext) => {
    const fd = new FormData();
    fd.append("audio", blob, `dictation.${ext}`);
    return axios.post(`${API}/transcribe`, fd, { timeout: 90000 }).then((r) => r.data);
  },
  changeVoice: (id, voice_style) => axios.put(`${API}/projects/${id}/voice`, { voice_style }).then((r) => r.data),
  updateScene: (id, idx, payload) =>
    axios.put(`${API}/projects/${id}/scenes/${idx}`, payload).then((r) => r.data),
};
